import { ReactNode } from "react";

export const HeadingWrapper = ({ children }: { children: ReactNode }) => (
  <div className="flex flex-col justify-between px-4 mb-6 sm:flex-row sm:items-center sm:px-0">
    {children}
  </div>
);
